module.exports = __webpack_public_path__ + "static/media/contact.37b955f1.svg";